export default __webpack_public_path__ + "static/media/1790all.d8e7e2ad.JPG";